import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=92aa8d08&scoped=true&"
import script from "./CommentForm.vue?vue&type=script&lang=js&"
export * from "./CommentForm.vue?vue&type=script&lang=js&"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=92aa8d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92aa8d08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92aa8d08')) {
      api.createRecord('92aa8d08', component.options)
    } else {
      api.reload('92aa8d08', component.options)
    }
    module.hot.accept("./CommentForm.vue?vue&type=template&id=92aa8d08&scoped=true&", function () {
      api.rerender('92aa8d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/CommentForm.vue"
export default component.exports